import api from "./api";

async function getLedgerPayments() {
  try {
    const response = await api.get("api/ledgerPayments");
    return response.data;
  } catch (error) {
    return [];
  }
}

async function getLedgerPayment(id) {
  try {
    const response = await api.get(`api/ledgerPayments/${id}`);
    return response.data;
  } catch (error) {
    return [];
  }
}

async function reconcileLedgerPayment(id) {
  try {
    const response = await api.post(
      `api/ledgerPayments/${id}/reconcile`,
    );
    return response.data;
  } catch (error) {
    return [];
  }
}

async function markLedgerPaymentReconciled(id) {
  try {
    const response = await api.post(
      `api/ledgerPayments/${id}/markasReconciled`,
    );
    return response.data;
  } catch (error) {
    return [];
  }
}

async function addLedgerPaymentAllocation(
  id,
  ledgerTransactionId) {
  try {
    const response = await api.post(
      `api/ledgerPayments/${id}/allocations`,
      {
        ledgerTransactionId
      }
    );

    return response.data;
  } catch (error) {
    return [];
  }
}

async function deleteLedgerPaymentAllocation(
  id,
  allocationId) {
  try {
    const response = await api.delete(
      `api/ledgerPayments/${id}/allocations/${allocationId}`,
    );
    return response.data;
  } catch (error) {
    return [];
  }
}

export {
  getLedgerPayments,
  getLedgerPayment,
  reconcileLedgerPayment,
  markLedgerPaymentReconciled,
  addLedgerPaymentAllocation,
  deleteLedgerPaymentAllocation
}